/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartDocumentAliases {
  BUTTON_CANCEL = 'button-cancel',
  BUTTON_INACTIVATE = 'button-inactivate',
  FIELD_UPLOADER = 'field-uploader',
  FILE_DOCUMENT_UPLOADER = 'file-document-uploader',
  FORM_DOCUMENT = 'form-document',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_DOCUMENT = 'layout-document',
  PANEL_DOCUMENT = 'panel-document',
}
export { MyChartDocumentAliases };
